<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="col-12 form-horizontal min-signup-form mb-55">
      <div class=" row">
        <div class="col-md-12 pb-3 min-heading-sec">
          <h3>Fullført</h3>
        </div>
      </div>


      <div class=" row">
        <p class="col-md-12 mb-5 mt-4">Din konto har blitt opprettet. Vennligst logg inn med ditt nye passord.

        </p>
      </div>
      <div class=" row">
        <div class="col-md-12 text-center">

          <button (click)="authService.routeToLogin(destination)" mat-raised-button  class="btn-submit btn-yellow mb-5">Logg Inn</button>
        </div>

      </div>

    </div>
  </div>
</div>
<form class="form-horizontal"  >


</form>
